import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import Logger from 'js-logger';
import RestService from '../../service/RestService';
// eslint-disable-next-line
'use strict';
export default {
  install: function install(Vue) {
    Logger.useDefaults();
    var logLevel = Logger.OFF;
    // eslint-disable-next-line
    switch (ENV) {
      case 'development':
        logLevel = Logger.DEBUG;
        break;
      case 'production':
        logLevel = Logger.ERROR;
        break;
      // eslint-disable-next-line
      default:
        throw new Error('Unsupported environment - ' + ENV);
    }
    Logger.setLevel(logLevel);
    var consoleHandler = Logger.createDefaultHandler();
    var sendToBackend = function sendToBackend(messages, context) {
      // Send messages to the backend for analysis.
      var payload = {};
      payload['message'] = _JSON$stringify(messages[0]);
      payload['timestamp'] = new Date().getTime();
      payload['level'] = context.level.name;
      payload['url'] = location.href;
      new RestService().sendClientLog(payload);
    };
    Logger.setHandler(function (messages, context) {
      consoleHandler(messages, context);
      sendToBackend(messages, context);
    });
    Object.defineProperty(Vue.prototype, '$log', { value: Logger });
  }
};


// WEBPACK FOOTER //
// ./src/plugins/logger/jslogger.js